import { getUserPuid } from 'mini-common-utils/lib/utils/getUserPuid';

/**
 * Gets the key to be used in local storage
 * @param key is the localStorage key
 * @returns key suffixed with user puid
 */
export default function getLocalStorageKey(key: string) {
    const puid = getUserPuid();
    return `mini-${puid}-${key}`;
}
